// SDK methods don't accept AbortSignal; injecting it via the constructor's
// http wrapper is the only way to make calls cancellable.
export function createHttp(signal?: AbortSignal): {
  fetch(input: RequestInfo, init?: RequestInit): Promise<Response>
} {
  return {
    fetch(input, init) {
      return globalThis.fetch(input, { ...init, signal })
    },
  }
}